import { Component, OnInit, Inject } from '@angular/core';
import { User } from 'src/app/entity/user';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/user/user.service';
import { Router } from '@angular/router';
import { Role } from 'src/app/entity/role';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';

@Component({
  selector: 'app-user-detail-view',
  templateUrl: './user-detail-view.component.html',
  styleUrls: ['./user-detail-view.component.scss'],
})
export class UserDetailViewComponent implements OnInit {
  entity: User;
  isNew: boolean;
  roles: Role[];
  selectedRole: Role;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<UserDetailViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private userService: UserService,
    private snackService: SnackbarService
  ) {
    this.entity = data;
    console.log(data.idGuid);
    console.log(data.name);
    this.isNew = data.idGuid === undefined;
    console.log(this.isNew);
  }

  ngOnInit(): void {
    this.userService.getRoles().subscribe((res) => {
      this.roles = res;
      console.log(this.roles);
    });
  }

  saveUser(): void {
    if (this.isNew) {
      this.userService.createUser(this.entity).subscribe(
        () => {
          this.snackService.open(
            'user.detail.snackbar.userCreated',
            4,
            'success'
          );
          this.dialogRef.close();
        },
        (error) => {
          this.snackService.open('shared.snackbar.saveFailure', 6, 'failed');
        }
      );
    } else {
      this.entity.password = null;
      this.userService.updateUser(this.entity).subscribe(
        () => {
          this.snackService.open(
            'user.detail.snackbar.userEdited',
            4,
            'success'
          );
          this.dialogRef.close();
        },
        (error) => {
          this.snackService.open('shared.snackbar.saveFailure', 6, 'failed');
        }
      );
    }
  }

  abort(): void {
    this.dialogRef.close();
  }
}
